import Vue from 'vue'
import firebase from '@/firebase/index'

const state = {
  latitude: null,
  longitude: null,
};

const mutations = {
  setLocation: (state, payload) => {
    state.latitude = payload.latitude
    state.longitude = payload.longitude
  },
};

const actions = {
};

const getters = {
  location: state => {
    return { latitude: state.latitude, longitude: state.longitude }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/location.js